module.exports = __webpack_public_path__ + "static/media/hockey-sticks.847c0f2f.svg";